<template>
<div>
    <smallbutton toplabel="Add Wallet" @click="AddParent()" v-if="showButton"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form id="walletform" ref="walletform" @submit.prevent>
                <label class="titlelabel">Add Wallet/Payer</label>
                <formentry label="Wallet/Payer First Name" :isrequired='trueParam' v-model="parent.FirstName" />
                <formentry label="Wallet/Payer Last Name" :isrequired='trueParam' v-model="parent.LastName"  />
                <formentry  inputtype="tel"  label="Phone Number" @blur="leavePhone"  v-model="parent.PhoneNumber1" />
                <formentry  inputtype="email"  label="Email Address" :isrequired='trueParam' v-model="parent.EmailAddress" />
                

                <div class="entry">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="">Role</label>
                    </div>
                    <select name="" id="" class='entrySelect' v-model="parent.personRoleId" required v-if='allowSelectPersonRole'>
                        <option v-for="role in personRoleList" :key="role.id" :value="role.id" >
                            {{role.name}}
                        </option>
                    </select>
                </div>

                <formentry  inputtype="password"  label="Password" :isrequired='trueParam' v-model="parent.password" />
                <formentry  inputtype="password"  label="Confirm Password" :isrequired='trueParam' v-model="parent.confirmPassword" />
                
                <div class="vertFlex ">
                    <label for="" class="mediumtext">How do you want to receive updates?</label>
                    <label for="" class="mediumtext">(choose at least one)</label>
                
                    <div class="horizFlex topMargin centered">
                        <input class="entryCheckbox" type="checkbox" v-model="parent.optInForText" >
                        <label for="" :class="checkClass(parent.optInForText)">Via mobile phone text message </label>
                    </div>
                    <label for="" class="mediumtext">(Standard messaging and data rates may apply.)</label>
                    <div class="horizFlex centered">
                        <input class="entryCheckbox" type="checkbox" v-model="parent.optInForEmail" >
                        <label for="" :class="checkClass(parent.optInForEmail)">Via email</label>
                    </div>
                </div>
    
                <smallbutton  @click="saveNewParent()" toplabel="Save" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
          </form>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
export default {
    name:'newwallet',
    components:{
        smallbutton,
        actionmodal,
        formentry
    },
    props:{

        showButton:{
            type:Boolean,
            default:true
        }
    },
    mixins:[datamethods,format],
    data(){
        return{
            parent:{},
            message:'',
            personRoleList:[],
            personRoleId:0,
            trueParam:true
        }
    },
    computed:{
        allowSelectPersonRole(){
            if(window.ALLOW_SELECT_PERSON_ROLE==undefined){return false}
            else{return window.ALLOW_SELECT_PERSON_ROLE}
        },
    },
    methods:{
        async AddParent(){
            this.parent={
                FirstName:'',
                LastName:'',
                PhoneNumber1:'',
                EmailAddress:'',
                optInForEmail:false,
                optInForText:false,
                password:'',
                confirmPassword:''
            }
            this.getRoles()
            this.$refs.mymodal.openModal()
        },
        checkClass(selected){
            if(selected){
                return "entryCheckLabelbold"
            }else{
                return "entryCheckLabel"
            }
        },
        async saveNewParent(){
            if(!this.$refs.walletform.checkValidity()){
                this.message = "Please fill in all required fields"
                return
            }
            if(!this.parent.optInForText && !this.parent.optInForEmail){
                this.message="Please select either text or email updates"
                return
            }
            if(this.parent.optInForText && this.parent.PhoneNumber1==''){
                this.message="Please enter a phone number for text updates"
                return
            }

            let req = {
                person:this.parent,
            }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'addpersonandwallet')
            if(response.Successful){
                this.$refs.mymodal.closeModal()
                console.log(response)
                this.$emit('refresh',response.walletId)
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        leavePhone(){

            this.parent.PhoneNumber1=this.$options.filters.formatPhone(this.parent.PhoneNumber1);
            
            
        },
        async getRoles(){
            let req = {
                locationId:-1
            }
            //this.beforeAPI();
            var response = await this.callAPI(req,'rolelist')

            //handle response
            if(response.Successful){
            this.personRoleList = response.PersonRoleList
    
            if(this.personRoleList.length>0){
               //find student and pick it as default
                var studentId=-1
                this.personRoleList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.name=='Student'){
                        studentId=acct.id
                    }
                }
                //this.personRoleId=studentId 
            }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
    }
}
</script>

<style>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
</style>





























